export default "__VITE_ASSET__BR1e_RAv__"